/** Helpers e limites de mídia do chat Atendabot (áudio/imagem). */

export const AUDIO_MIME_CANDIDATES = [
  'audio/mp4',
  'audio/webm;codecs=opus',
  'audio/webm',
];

export const MAX_AUDIO_DURATION_MS = 60_000;
export const MAX_AUDIO_BYTES = 8 * 1024 * 1024; // 8MB
export const MAX_IMAGE_BYTES = 8 * 1024 * 1024; // 8MB
export const SUPABASE_BUCKET_TMP_MEDIA = 'tmp-media';

export const pickMimeType = () => {
  if (typeof MediaRecorder === 'undefined' || typeof MediaRecorder.isTypeSupported !== 'function') {
    return '';
  }
  for (const type of AUDIO_MIME_CANDIDATES) {
    try {
      if (MediaRecorder.isTypeSupported(type)) return type;
    } catch {
      // Alguns browsers lançam ao consultar codecs não suportados — tentar o próximo.
    }
  }
  return '';
};

export const getAudioExtension = (mimeType) => {
  const normalized = String(mimeType || '').toLowerCase();
  if (normalized.includes('mp4')) return 'm4a';
  if (normalized.includes('ogg')) return 'ogg';
  if (normalized.includes('webm')) return 'webm';
  return 'webm';
};

export const getImageExtension = (file) => {
  const type = file?.type?.toLowerCase() || '';
  if (type.includes('jpeg')) return 'jpg';
  if (type.includes('png')) return 'png';
  if (type.includes('webp')) return 'webp';
  if (type.includes('gif')) return 'gif';
  if (type.includes('heic')) return 'heic';
  const nameExt = file?.name?.split('.').pop()?.toLowerCase();
  if (nameExt && nameExt.length <= 5) return nameExt;
  return 'jpg';
};

export const formatDuration = (ms) => {
  const total = Math.max(0, Math.floor(ms / 1000));
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
};

export const buildUuid = () => {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
};
